<template>
  <div>
    <v-sheet class="d-flex align-center" color="white">
      <v-btn icon @click="volver">
        <v-icon color="primary">west</v-icon>
      </v-btn>
      <span class="ml-2 font-weight-medium">{{ razonSocial }}</span>
    </v-sheet>

    <v-data-table
      class="pt-2"
      :headers="ENCABEZADOS_DOCUMENTOS"
      :items="datosFiltrados"
      :page.sync="pagina"
      :items-per-page.sync="itemsPorPagina"
      :loading="cargando"
      hide-default-footer
      :footer-props="opcionesPaginacion"
    >
      <template #footer>
        <data-table-pagination
          :pagina="pagina"
          :items-por-pagina="itemsPorPagina"
          :total-items="totalItemsFiltrados"
          :loading="cargando"
          @update:pagina="actualizarPagina"
          @update:items-por-pagina="actualizarItemsPorPagina"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import DataTablePagination from '../../../../components/Table/DataTablePagination.vue';
import { paginacionMixin } from '../../../../mixins/paginacionMixin';

const ENCABEZADOS_DOCUMENTOS = [
  { text: 'Número Docto', align: 'center', value: 'Docto' },
  { text: 'Valor Docto', align: 'center', value: 'Saldo' },
];

export default {
  name: 'TablaCarteraDocumentos',

  components: {
    DataTablePagination,
  },

  mixins: [paginacionMixin],

  props: {
    cargando: {
      type: Boolean,
      default: false,
    },
    documentos: {
      type: Array,
      default: () => [],
    },
    razonSocial: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      ENCABEZADOS_DOCUMENTOS,
    };
  },

  computed: {
    datosParaPaginar() {
      return this.documentos;
    },

    opcionesPaginacion() {
      return { itemsPerPageOptions: [10, 50, 100, -1] };
    },
  },

  methods: {
    volver() {
      this.$emit('volver');
    },
  },
};
</script>
